"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
function CustomModal(props) {
    var _a, _b;
    const label = props.label;
    const children = props.children;
    const buttonClass = props.buttonClass;
    const [show, setShow] = react_1.default.useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("button", { className: buttonClass, onClick: handleShow }, (_a = props.icon) !== null && _a !== void 0 ? _a : label),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: handleClose, size: (_b = props.size) !== null && _b !== void 0 ? _b : "lg" },
            react_1.default.createElement("div", { className: '' },
                react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                    react_1.default.createElement(react_bootstrap_1.Modal.Title, null, label)),
                react_1.default.createElement(react_bootstrap_1.Modal.Body, null, typeof children === 'function' ? children(handleClose, handleShow) : children),
                react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                    react_1.default.createElement("button", { className: 'btn btn-secondary', onClick: handleClose }, "\u0625\u063A\u0644\u0627\u0642"))))));
}
exports.default = CustomModal;
